import React from "react";
import { useLang } from "../../context/lang-context";

const LandingNav: React.FC = () => {
  const { lang, setLang, t } = useLang();

  return (
    <nav className="navbar navbar-expand-md fixed-top landing-nav">
      <div className="container">
        <a className="navbar-brand" href="/">
          <img src="/img/logo_svg.svg" alt="Foo" className="nav-logo" />
        </a>
        <button
          className="btn btn-outline-dark btn-sm lang-toggle"
          onClick={() => setLang(lang === "es" ? "en" : "es")}
          aria-label={t("Cambiar a inglés", "Switch to Spanish")}
        >
          {lang === "es" ? "EN" : "ES"}
        </button>
      </div>
    </nav>
  );
};

export default LandingNav;
